module.exports = __webpack_public_path__ + "img/github.0b1eb655.svg";